@import '../../../global/global.pcss';

[part='backdrop'] {
  @apply pointer-events-none;
}

atomic-focus-trap {
  @apply contents;
}

[part='container'] {
  @apply overflow-hidden;
  grid-area: modal;
}

.animate-scaleUpModalIPX[part='container'] {
  @apply rounded shadow;
}

:host(.open) {
  [part='backdrop'] {
    @apply pointer-events-auto;
  }
}

:host(.open.dialog) {
  [part='backdrop'] {
    background-color: rgba(40, 40, 40, 0.8);
  }
}

:host(.dialog) {
  [part='backdrop'] {
    @apply grid p-6;
    transition: background-color 500ms ease-in-out;

    grid-template-areas:
      '. .     .'
      '. modal .'
      '. .     .';

    grid-template-columns: 1fr min(30rem, 100%) 1fr;
    grid-template-rows: 1fr auto 3fr;
  }

  [part='container'] {
    @apply rounded shadow;
  }

  [part='header-wrapper'] {
    @apply px-6 py-4;
  }

  [part='header'] {
    @apply font-bold;
  }

  [part='body-wrapper'] {
    @apply p-6;
  }

  [part='footer-wrapper'] {
    @apply bg-neutral-light;
    padding: 1rem 1.125rem;
  }
}

:host(.fullscreen) {
  [part='container'] {
    @apply absolute inset-0;
  }

  [part='header-wrapper'] {
    @apply p-6;
  }

  [part='body-wrapper'] {
    @apply px-6 pb-5 pt-8;
  }

  [part='footer-wrapper'] {
    @apply shadow-t-lg px-6 py-4;
  }
}
